import { fetchApi } from '@/config/axiosSetting.ts';
import { PersonalInformationOwnerType } from '@/modules/adjusterReportModules/IncidentParticipants/types/OwnerType';

export const PatchDamagedUserInformationQueryFunction = (
  id: string,
  params: PersonalInformationOwnerType,
  damaged_id: string,
) =>
  fetchApi({
    method: 'PATCH',
    url: `/property/reports/${id}/accident_users/damaged/user_information/owner/personal_information/`,
    data: params,
    params: { damaged_id },
  });
